import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';
import DocumentDetails from '@/views/public/DocumentDetails';
import ArticleSubmit from '@/views/public/ArticleSubmit';
import UnifiedDebateView from '@/views/debate/UnifiedDebateView';
import DocumentTeam from '@/views/public/DocumentTeam';
import ClientDocuments from '@/views/public/ClientDocuments';
import TeamSettings from '@/views/public/TeamSettings';
import TeamMember from '@/views/public/TeamMember';
import InvitationLanding from '@/views/public/InvitationLanding';
import ChallengeUrlInvitation from '@/views/public/ChallengeUrlInvitation';
import WebAppLandingPage from '@/views/public/WebAppLandingPage';
import MobileLandingPage from '@/views/public/MobileLandingPage';
import AccountDetails from '@/views/public/AccountDetails';
import WelcomePanel from '@/views/public/WelcomePanel';
import UsersAdmin from './views/public/UsersAdmin';
import UserAdmin from './views/public/UserAdmin';
import ClientInvitations from './views/public/ClientInvitations';
import ClientContacts from './views/public/ClientContacts';
import ContactsTeamManage from './views/public/ContactsTeamManage';
import ClientOrganizations from './views/public/ClientOrganizations';
import OrganizationCreate from './views/public/OrganizationCreate';
import OrganizationDetails from './views/public/OrganizationDetails';
import OrganizationTeamDetails from './views/public/OrganizationTeamDetails';
import TwitterLogin from './components/social/twitter/TwitterLogin';
import cookies from '@/assets/js/cookies';

const routes = [
  {
    path: '/beta',
    name: 'WelcomePanel',
    component: WelcomePanel,
    meta: {
      canView: () => true,
    },
  },
  {
    path: '/mobileuser',
    name: 'MobileUser',
    component: MobileLandingPage,
    meta: {
      canView: () => true,
    },
    beforeEnter: (to, from, next) => {
      store.commit('setMobileStaticPage', true);
      next();
    },
  },
  {
    path: '/account',
    name: 'AccountDetails',
    component: AccountDetails,
    meta: {
      canView: () => !!store.state.userData,
    },
  },
  // NOTE: Inbox route migrated to v2 - see v2/features/inbox
  // {
  //   path: '/inbox',
  //   name: 'Inbox',
  //   component: ClientInvitations,
  //   meta: {
  //     canView: () => !store.state.publicView,
  //   },
  // },
  {
    path: '/discussions',
    name: 'Discussions',
    component: ClientDocuments,
    meta: {
      canView: () => !store.state.publicView,
    },
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: ClientContacts,
    meta: {
      canView: () => !store.state.publicView,
    },
  },
  {
    path: '/contacts/manageteam',
    name: 'Manage Roster',
    component: ContactsTeamManage,
    meta: {
      canView: () => !store.state.publicView,
    },
  },
  {
    path: '/organizations',
    name: 'Organizations',
    component: ClientOrganizations,
    meta: {
      canView: () => !store.state.publicView,
    },
  },
  {
    path: '/organization/create',
    name: 'Create New Organization',
    component: OrganizationCreate,
    meta: {
      canView: () => false,
    },
  },
  {
    path: '/organization-team/create',
    name: 'Create New Organization Team',
    component: OrganizationTeamDetails,
    meta: {
      canView: () => false,
    },
  },
  {
    path: '/organization-team/:id',
    name: 'Organization Team Details',
    component: OrganizationTeamDetails,
    meta: {
      canView: () => false,
    },
  },
  {
    path: '/organization/:id',
    name: 'Organizations Details',
    component: OrganizationDetails,
    meta: {
      canView: () => !store.state.publicView,
    },
  },
  {
    path: '/document-details/:documentID',
    name: 'Document Details',
    component: DocumentDetails,
    meta: {
      canView: () => store.state.userData?.documents,
    },
    beforeEnter: (to, from, next) => {
      store.commit('setCurrentDocumentID', to.params.documentID);
      next();
    },
  },
  {
    path: '/submit-new-article',
    name: 'Submit New Article for Discussion',
    component: ArticleSubmit,
    meta: {
      canView: () => false,
    },
  },
  {
    path: '/team-members/:documentID',
    name: 'Team Members',
    component: DocumentTeam,
    meta: {
      canView: () => false,
    },
    beforeEnter: (to, from, next) => {
      store.commit('setCurrentDocumentID', to.params.documentID);
      next();
    },
  },
  {
    path: '/new-team-member',
    name: 'New Team Member',
    component: TeamMember,
    meta: {
      canView: () => false,
    },
    beforeEnter: (to, from, next) => {
      store.commit('setCurrentTeamMemberID', null);
      next();
    },
  },
  {
    path: '/team-settings/:documentId/:teamId',
    name: 'Team Settings',
    component: TeamSettings,
    meta: {
      canView: () => false,
    },
    beforeEnter: (to, from, next) => {
      if (!store.state.currentTeam?._id) store.commit('setCurrentTeam', { _id: to.params.teamId });
      next();
    },
  },
  {
    path: '/team-member-details/:teamMemberID',
    name: 'Team Member Details',
    component: TeamMember,
    meta: {
      canView: () => false,
    },
    beforeEnter: (to, from, next) => {
      store.commit('setCurrentTeamMemberID', to.params.teamMemberID);
      next();
    },
  },
  {
    path: '/invitation/:invitationID',
    name: 'InvitationLand',
    component: InvitationLanding,
    meta: {
      canView: () => !store.state.publicView,
    },
    beforeEnter: (to, from, next) => {
      next();
    },
  },
  {
    path: '/challenge/:challengeID',
    name: 'Challenge',
    component: ChallengeUrlInvitation,
    meta: {
      canView: () => !store.state.publicView,
    },
    beforeEnter: (to, from, next) => {
      store.commit('setChallengeUrl', true);
      next();
    },
  },
  {
    path: '/invitation/:invitationID/:status',
    name: 'Invitation',
    component: WebAppLandingPage,
    meta: {
      canView: () => !store.state.publicView,
    },
    beforeEnter: (to, from, next) => {
      store.commit('setAcceptDecline', true);
      store.commit('setAcceptDeclineStatus', to.params.status);
      next();
    },
  },
  {
    path: '/users-admin',
    name: 'Users',
    component: UsersAdmin,
    meta: {
      canView: () =>
        !!store.state.userData &&
        !!store.state.userData.globalRoles &&
        store.state.userData.globalRoles.includes('superadmin'),
    },
  },
  {
    path: '/user-admin/:userId',
    name: 'User',
    component: UserAdmin,
    meta: {
      canView: () =>
        !!store.state.userData &&
        !!store.state.userData.globalRoles &&
        store.state.userData.globalRoles.includes('superadmin'),
    },
  },
  {
    path: '/debate/:documentID',
    name: 'Debate',
    component: UnifiedDebateView,
    props: { viewType: 'regular' },
    meta: {
      canView: () => false,
    },
    beforeEnter: (to, from, next) => {
      store.commit('setCurrentDocumentID', to.params.documentID);
      store.commit('setBasisEdited', false);

      if (to.query.linkId && to.params.counterpointMode === 'public') {
        store.commit('setPublicLinkId', to.query.linkId);
        store.commit('setPublicView', true);
        if (to.query.ann) store.commit('setPublicTargetAnnotationId', to.query.ann);
        if (to.query.n) store.commit('setPublicTargetNetwork', to.query.n);
      }
      next();
    },
  },
  {
    path: '/curatordebate/:documentID',
    name: 'CuratorDebate',
    component: UnifiedDebateView,
    props: { viewType: 'curator' },
    meta: {
      canView: () => false,
    },
    beforeEnter: (to, from, next) => {
      store.commit('setCurrentDocumentID', to.params.documentID);
      store.commit('setBasisEdited', false);

      if (to.query.linkId && to.params.counterpointMode === 'public') {
        store.commit('setPublicLinkId', to.query.linkId);
        store.commit('setPublicView', true);
        if (to.query.ann) store.commit('setPublicTargetAnnotationId', to.query.ann);
        if (to.query.n) store.commit('setPublicTargetNetwork', to.query.n);
      }
      next();
    },
  },
  {
    path: '/publicview/debate/:documentID',
    name: 'PublicDebate',
    component: UnifiedDebateView,
    props: { viewType: 'public' },
    meta: {
      canView: () => false,
    },
    beforeEnter: (to, from, next) => {
      store.commit('setPublicView', true);
      store.commit('setCurrentDocumentID', to.params.documentID);
      next();
    },
  },
  {
    path: '/social/twitter/login',
    name: 'Twitter Login',
    component: TwitterLogin,
    beforeEnter: (to, from, next) => {
      store.commit('setPublicView', true);
      store.commit('hideSidebar');
      store.commit('hideTopbar');

      const parentWindowTweetParams = window.opener.TwitterPopupGetParams();
      if (
        parentWindowTweetParams.userId &&
        !['null', 'undefined'].includes(parentWindowTweetParams.userId)
      ) {
        store.commit('setAuthInitialized', true);
      }
      store.commit('setPublicLinkId', parentWindowTweetParams.linkId);
      store.commit('setDocument', {
        _id: parentWindowTweetParams.docId,
        title: decodeURIComponent(parentWindowTweetParams.docTitle),
      });
      store.commit('setPublicTargetAnnotationId', parentWindowTweetParams.annotation);
      if (parentWindowTweetParams.url)
        store.commit('setPublicTargetURL', decodeURIComponent(parentWindowTweetParams.url));
      if (parentWindowTweetParams.message)
        store.commit('setPublicPostMessage', decodeURIComponent(parentWindowTweetParams.message));
      // store.commit("setVisitor", { _id: parentWindowTweetParams.visitorId });
      store.commit('setPublicTargetNetwork', 'twitter');

      next();
    },
  },
  {
    path: '/social/twitter/callback',
    name: 'Twitter Callback',
    redirect: to => {
      console.log('Redirecting:', to);
      return '/social/twitter/login';
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.path !== '/' && to.path !== from.path && to.name !== null && !to.path.includes('public')) {
    cookies.setCookie(
      'latest-route',
      JSON.stringify({
        name: to.name,
        path: to.path,
      })
    );
  }
  if (store.state.userData) {
    store.dispatch('getNotifications');
  }

  // Retrieve the stored route information from the cookie

  console.log('TO :: ', to);
  // ###
  if (
    to.path.match(
      /public\/debate\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/
    )
  ) {
    const uuid = to.path.split('/').pop();

    store.commit('setPublicLinkDebateId', uuid);
    store.commit('setPublicView', true);
  }
  if (from.name === 'Edit Automate Outline for Discussion') {
    store.commit('toggleCounterpointSidePanel', false);
  }
  store.commit('setMetaTitle', to.name);
  if (
    [
      'Debate',
      'CuratorDebate',
      'PublicDebate',
      'Document Annotations',
      'Public View',
      'Analyze document for Discussion',
      'Edit Automate Outline for Discussion',
    ].includes(to.name)
  ) {
    store.commit('hideSidebar');
    store.commit('showTopbar');
  } else if (
    [
      'Organizations',
      'AccountDetails',
      'Discussions',
      'Inbox',
      'Contacts',
      'Team Settings',
    ].includes(to.name)
  ) {
    store.commit('showSidebar');
    store.commit('hideTopbar');
  } else if (['Document Details'].includes(to.name)) {
    store.commit('hideSidebar');
    store.commit('hideTopbar');
  } else store.commit('showSidebar');
  if (to.path === from.path) {
    // Navigation is redundant, do not proceed
    next(false);
  } else {
    // Navigation is valid, proceed
    next();
  }
});

/**
 * Add a custom map for all routes
 * This functions creates a map where every route can:
 *    1. be called by it's name (without white spaces)
 *    2. be passed the parameters as arguments in order of appearance in the path
 *    3. return the path with the respective parameters replaced by the arguments passed
 *
 * For example:
 *    When Retrieving the path for "Team Settings" with documentId = '12345' and teamId = '67890' run:
 *      router.routesMap.TeamSettings('12345', '67890');
 *    and the get the path:
 *      '/team-settings/12345/67890'
 *    which is the correct path for the Team Settings screen with the documentId
 *    and teamId parameters properly added to their respective positions in the path template
 */
const _routesMap = routes.reduce((obj, r) => {
  let argNames = r.path.match(/:[\w]+/g); // extract path parameters
  return {
    ...obj,
    // generate property name based on route name without white spaces
    [r.name.replaceAll(' ', '')]: (
      ...args // create function with custom arguments
    ) =>
      argNames
        ? argNames.reduce((str, argName, i) => str.replace(argName, args[i]), r.path)
        : r.path, // replace path parameters with argument values
  };
}, {});
router.routesMap = _routesMap;
router.pushRoute = Object.entries(_routesMap).reduce(
  (obj, [k, v]) => ({ ...obj, [k]: (...args) => router.push(v(...args)) }),
  {}
);

export default router;
